<template>
  <!-- 数采器信息 -->
  <div class="devicebelonginfo devicebelonginfoNew">
    <!-- {{dataloggerPay}} -->
    <div class="infobox">
      <!-- 基本信息 -->
      <div class="title ggTitle1">{{ `${$t("datalogger.basic_info")}` }}</div>
      <div class="cell name light ggCell11 splitHLine">{{ $t("recharge.DataloggerName") }}</div>
      <div class="cell data dark ggCell12 splitHLine">{{ dataloggerInfo2.alias || "--" }}</div>
      <div class="ggCell01 splitVBox"></div>
      <div class="cell name light ggCell13 splitHLine">{{ $t("datalogger.Datalogger_model") }}</div>
      <div class="cell data dark ggCell14 splitHLine">{{ dataloggerInfo2.descx || "--" }}</div>
      <!-- 信号 -->
      <div class="cell name light ggCell21 splitHLine">{{ $t("recharge.Signal") }}</div>
      <div class="cell data dark ggCell22 splitHLine">
        <!-- {{dataloggerInfo2.signal}} -->
        <signal class="signalBox" :strength="dataloggerInfo2.signal" style="justify-content:flex-start;"></signal>
      </div>
      <div class="ggCell02 splitVBox"></div>
      <div class="cell name light ggCell23 splitHLine">{{ $t("datalogger.load") }}</div>
      <div class="cell data dark ggCell24 splitHLine">{{ dataloggerInfo2.load || "--" }}</div>
      <div class="cell name light ggCell31 splitHLine">{{ $t("datalogger.installer") }}</div>
      <div class="cell data dark ggCell32 splitHLine">{{ dataloggerInfo1.address.installer || "--" }}</div>
      <div class="ggCell03 splitVBox"></div>
      <div class="cell name light ggCell33 splitHLine">{{ $t("datalogger.install_date") }}</div>
      <div class="cell data dark ggCell34 splitHLine">{{ dataloggerInfo1.address.installDate || "--" }}</div>
      <!-- <div class="cell name light ggCell41">{{$t('datalogger.Communication_balance')}}</div> -->
      <!-- 充值  @click="showDetail" -->
      <!-- <div class="cell data dark ggCell42" style="position:relative;">
        {{dataloggerInfo2.balance}}
        
        <el-button 
          v-if="dataloggerPay[0] && dataloggerPay[0].gprsStatus == 0"
          class="todetail toPay"
          @click="openRecharge(dataloggerInfo2)"
        >
          {{$t('recharge.Recharge')}}
        </el-button>
      </div> -->
      <div class="ggCell04 splitVBox"></div>
      <div class="cell name light ggCell41 splitHLine">{{ $t("datalogger.Firmware_Version") }}</div>
      <div class="cell data dark ggCell42 splitHLine">{{ dataloggerInfo2.fireware || "--" }}</div>
      <!-- 流量充值 -->
      <div class="title ggTitle3" v-if="GprsStatus">
        {{ `${$t("datalogger.GPRS_traffic")}` }}
        <el-button class="todetail toPay" @click="openRecharge(dataloggerInfo2)">
          {{ $t("recharge.Recharge1") }}
        </el-button>
      </div>
      <div class="cell name light ggCell71" v-if="GprsStatus">{{ $t("datalogger.Flowcard_status") }}</div>
      <div class="cell data dark ggCell72" v-if="GprsStatus">
        <template>
          <div v-if="gprsStatus == '0'" style="color:#22ac38;;">{{ $t("recharge.normal") }}</div>
          <div v-if="gprsStatus == '1'" style="color:#EC9630;">{{ $t("recharge.warning") }}</div>
          <div v-if="gprsStatus == '2'" style="color:#3296fa;">{{ $t("recharge.Overdue") }}</div>
          <div v-if="gprsStatus == '3'" style="color:#ccc;">{{ $t("recharge.expired") }}</div>
          <div v-if="gprsStatus == '4'" style="color:#ff7c79;">{{ $t("recharge.unknown") }}</div>
        </template>
      </div>
      <div class="ggCell07 splitVBox" v-if="GprsStatus"></div>
      <div class="cell name light ggCell73" v-if="GprsStatus">{{ $t("recharge.CCID_time") }}</div>
      <div class="cell data dark ggCell74" v-if="GprsStatus">{{ dataloggerInfo2.edate }}</div>

      <!-- 位置信息 -->
      <div class="title ggTitle2">
        {{ `${$t("datalogger.location_info1")}` }}
      </div>
      <div class="cell name light ggCell51 splitHLine">{{ $t("datalogger.district") }}</div>
      <div class="cell data dark ggCell52 splitHLine">
        <!-- {{`${dataloggerInfo1.address.province} ${dataloggerInfo1.address.city} ${dataloggerInfo1.address.county}`}} -->
        {{
          `${dataloggerInfo1.address.province || "--"} ${dataloggerInfo1.address.city || ""}
                ${dataloggerInfo1.address.county || ""}`
        }}
      </div>
      <div class="ggCell05 splitVBox"></div>
      <div class="cell name light ggCell53 splitHLine">{{ $t("datalogger.timezone1") }}</div>
      <div class="cell data dark ggCell54 splitHLine">
        <!-- this.$filter.timezone -->
        {{ $filter.timezone[this.dataloggerInfo1.address.timezone] ? $filter.timezone[this.dataloggerInfo1.address.timezone].label : "--" }}
      </div>
      <div class="cell name light ggCell61">{{ $t("datalogger.dataloggerAddress") }}</div>
      <div class="cell data dark ggCell62">
        <!-- {{`${dataloggerInfo1.address.province} ${dataloggerInfo1.address.city} ${dataloggerInfo1.address.county} ${dataloggerInfo1.address.address}`}} -->
        {{
          `${dataloggerInfo1.address.province || ""} ${dataloggerInfo1.address.city || ""}
                ${dataloggerInfo1.address.county || ""} ${dataloggerInfo1.address.address || "--"}`
        }}
      </div>
      <div class="ggCell06 splitVBox"></div>
      <div class="cell name light ggCell63" v-if="!riyueyuanCode">{{ $t("datalogger.longi_lati") }}</div>
      <div v-if="!riyueyuanCode" class="cell data dark ggCell64">
        <!-- {{`经度${dataloggerInfo.lon} 纬度${dataloggerInfo.lat}`}} -->
        {{ $t("datalogger.longitude") }}&nbsp;{{ dataloggerInfo1.address.lon | formatNum(6) }} {{ $t("datalogger.latitude") }}&nbsp;{{
          dataloggerInfo1.address.lat | formatNum(6)
        }}
      </div>
    </div>

    <!-- 充值对话框(new) -->
    <!-- v-if="showRechargeDialog" -->
    <!-- :class="{'showDialog': showRechargeDialog, 'hideDialog': !showRechargeDialog}" -->
    <recharge-dialog
      :title="$t('menu.pay')"
      :visible.sync="showRechargeDialog"
      class="dialog-recharge"
      v-if="showRechargeDialog"
      width="780px"
      noFooter
    >
      <!-- v-if="currentStep===1" -->
      <el-form ref="form" :label-width="this.$lang.currentLang == 'zh_CN'||this.$lang.currentLang == 'en_US'||this.$lang.currentLang == 'en_ID'?'100px':'160px'" slot="content" class="step-one" v-if="currentStep === 1">
        <!-- 充值设备 -->
        <el-form-item :label="$t('recharge.rechargeDevice')" v-if="rechargingInfo">
          <el-tag
            v-for="(item, index) in rechargingInfo.pn"
            :key="item"
            :closable="rechargingInfo.pn.length > 1"
            @close="rechargingInfo.pn.splice(index, 1)"
            type="info"
            class="tag"
            >{{ item }}</el-tag
          >
        </el-form-item>
        <!-- 充值套餐 -->
        <el-form-item :label="$t('recharge.rechargePackage')" v-if="rechargingInfo">
          <span
            v-for="(item, index) in availablePackages"
            :key="index"
            class="package"
            :class="{ selected: rechargingInfo.package === item }"
            @click="rechargingInfo.package = item"
          >
            {{ item.duration }}
            <br />
            {{ item.label }}
          </span>
        </el-form-item>
        <!-- 支付方式 -->
        <el-form-item :label="$t('recharge.rechargeChannel')">
          <div class="payment-method-row">
            <div class="payment-method-card" :class="{active: PaymentMethod === 0}" @click="PaymentMethodClick(0)">
              <img src="../../../../assets/img/recharge/weixin.png" class="payment-icon" alt="">
              <div class="payment-info">
                <div class="payment-name">
                  <span>{{$t('recharge.Recharge_tip5')}}</span>
                  <span class="paybaseShow" :class="{payChoose: PaymentMethod === 0}"></span>
                </div>
                <div class="payment-desc">{{$t('recharge.Recharge_tip3')}}</div>
              </div>
            </div>
            <div class="payment-method-card" :class="{active: PaymentMethod === 5}" @click="PaymentMethodClick(5)">
              <img src="../../../../assets/img/recharge/paypal.png" class="payment-icon" alt="">
              <div class="payment-info">
                <div class="payment-name">
                  <span>Pay pal</span>
                  <span class="paybaseShow" :class="{payChoose: PaymentMethod === 5}"></span>
                </div>
                <div class="payment-desc">{{$t('recharge.Recharge_tip4')}}</div>
              </div>
            </div>
          </div>
        </el-form-item>
        <!-- 充值方式 -->
        <!-- <el-form-item :label="$t('recharge.rechargeChannel')">
          <div
            v-for="item in availableChannels"
            :key="item.name"
            class="capsule-wrapper"
            :class="{selected: rechargingInfo.channel===item}"
            @click="rechargingInfo.channel=item"
          >
            <div class="capsule-content">
              <img :src="item.img" :alt="item.name" />
            </div>
          </div>
        </el-form-item> -->
        <!-- 优惠 -->
        <!-- <el-form-item :label="$t('recharge.rechargeDiscount')">
          <span
            class="discount"
          >￥&nbsp;{{rechargingInfo.package.discount * rechargingInfo.pn.length}}</span>
        </el-form-item> -->
        <!-- 金额 -->
        <!-- <el-form-item :label="$t('recharge.rechargePrice')">
          <span
            class="price"
          >￥&nbsp;{{rechargingInfo.package.finalPrice * rechargingInfo.pn.length}}</span>
        </el-form-item> -->
        <div class="settlementbox" v-if="rechargingInfo">
          <!-- <img src="@/assets/img/appDownload.png" style="width:148px;height:148px;"/> -->
          <span class="settlementinfo">
            <!-- 支付 -->
            <span class="settlementnum">
              {{ `${$t("recharge.rechMoney")}&nbsp;${currencySymbol}&nbsp;${rechargingInfo.package.finalPrice * rechargingInfo.pn.length}` }}
            </span>
            <!-- 已优惠 -->
            <span class="settlementnum">
              {{ `${$t("recharge.rechDiscount")}&nbsp;${currencySymbol}&nbsp;${rechargingInfo.package.discount * rechargingInfo.pn.length}` }}
            </span>
            <!-- 请打开手机微信扫一扫完成支付 -->
            <!-- <span class="settlementscan">{{$t('recharge.rechScan')}}</span> -->
            <!-- 温馨提示：1、同一订单只能选择相同带载数和相同扶贫平台状态的设备(默认显示带载数为1和未接入扶贫平台的套餐)；
            2、充值逾期卡和在每月25号至5号进行充值都会延迟1~14天到帐，请耐心等待 -->
            <span class="settlementtip">{{ $t("recharge.rechTip") }}</span>
          </span>
        </div>
        <div style="text-align:right;margin-top:30px;">
          <button type="button" class="btn btn-light" style="margin-right:10px;" @click="closeRechargeDialog">{{ $t("recharge.cancel") }}</button>
          <button type="button" class="btn btn-dark" @click="confirmPay">{{ $t("recharge.confirm") }}</button>
        </div>
      </el-form>
      <!-- 生成与扫码 -->
      <div v-if="currentStep === 2" slot="content" class="step-two">
        <!-- <p class="prompt">{{$t('recharge.scan')}}</p> -->
        <p class="price">{{ currencySymbol }}{{ rechargingInfo.package.finalPrice *100 / 100}}</p>
        <div class="qr" ref="qr"></div>
        <p class="info"  v-if="PaymentMethod ==0">{{ $t("recharge.openWx") }}</p>
        <p class="info">{{ $t("recharge.scanComplete") }}</p>
      </div>
      <!-- v-if="currentStep===3" -->
      <div slot="content" class="step-three" v-if="currentStep === 3">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- 充值成功 -->
          <span class="showresulttext">{{ $t("recharge.Recharge_successful") }}</span>
          <!-- 查看充值记录 -->
          <button type="button" class="button-solid showresultbtn" @click="goRechargeRecord">{{ $t("recharge.Recharge_record") }}</button>
        </div>
      </div>
      <!-- v-if="currentStep===4" -->
      <div slot="content" class="step-three" v-if="currentStep === 4">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <!-- <span class="showresulttext">{{$t('recharge.Recharge_fail')}}</span> -->
          <span class="showresultname">{{ errorMsgTip }}</span>
          <button type="button" class="button-solid showresultbtn" @click="goRechargeRecord">{{ $t("recharge.Recharge_record") }}</button>
        </div>
      </div>
      <!-- <div slot="footer">
        <div v-if="currentStep===1">
          <button class="button-hollow" @click="closeRechargeDialog">{{$t('recharge.cancel')}}</button>
          <button class="button-solid" @click="confirmPay">{{$t('recharge.confirm')}}</button>
        </div>
        <div v-if="currentStep===2">
          <button class="button-hollow" @click="currentStep=1">{{$t('recharge.previous')}}</button>
        </div>
        <div v-if="currentStep===3">
          <button class="button-solid" @click="closeRechargeDialog">{{$t('createPlant.close')}}</button>
        </div>
      </div> -->
    </recharge-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import signal from "@/components/signalnew"
import rechargeDialog from "@/components/dialognew/flowIndex"
import wxpayImg from "@/assets/img/wxpay.png"
import QRCode from "qrcodejs2"
export default {
  props: {
    dataloggerInfo1: {
      type: Object
    },
    dataloggerInfo2: {
      type: Object
    }
  },
  components: {
    signal,
    rechargeDialog
  },
  data() {
    return {
      riyueyuanCode:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08"),
      payBtnDisabled: false,
      PaymentMethod: 0,
      // 充值弹框
      showRechargeDialog: false,
      // 当前充值步骤
      currentStep: 1,
      // 要充值充值的数采器
      dataloggerPay: [],
      rechargingInfo: null,
      // 可选套餐列表
      availablePackages: [],
      // 单选套餐
      radioOne: "1",
      // 可选充值方式列表
      availableChannels: [
        {
          name: "wxpay",
          value: 0,
          img: wxpayImg
        },
        // {
        //   name: 'alipay',
        //   value: 1,
        //   img: alipayImg
        // }
        {
          name: "paypal",
          value: 5,
          // img: wxpayImg
        }
      ],
      // 轮询扫码结果
      orderResultPolling: null,
      searchDatalogger: {
        status: "",
        pn: "",
        load: "",
        ccid: "",
        alias: ""
      },
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      // 数采器详情中GPRS类型设备增加充值 (0)
      gprsStatus: 4,
      //是否显示GPRS流量充值
      GprsStatus: false
    }
  },
  created() {
    // this.getDataloggerInfo();
    // this.getDataloggerInfo2();
    if(this.dataloggerInfo2.pn)
    this.queryData()
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo"
    }),
    currencySymbol() {
      return this.PaymentMethod === 5 ? '$' : '￥';
    }
  },
  watch: {
    showRechargeDialog(val) {
      if (!val) {
        this.currentStep = 1
        this.rechargingInfo = null
      }
    },
    currentStep(val) {
      // 清除轮询
      if (val !== 2) {
        clearInterval(this.orderResultPolling)
        this.orderResultPolling = null
      }
    },
    // 变化时获取要充值数采器数据
    dataloggerInfo2() {
      this.queryData()
    }
  },
  methods: {
    // 查看充值记录
    goRechargeRecord () {
      this.$router.push({ path: `/generalNew/setting/rechargeRecord` });
    },
    // 查看数采器信息(1)
    // (设备：01352419520097 ; pn: 'Q0021280990582')
    // getDataloggerInfo() {
    //   this.$request.get("queryCollectorinfoEs", { pn:this.deviceInfo.pn}).then(res => {
    //     if (res.err === 0) {
    //       // console.log('online-数采器信息1', res.dat);
    //       // this.dataloggerInfo1 = { pn:this.deviceInfo.pn, ...res.dat };
    //       this.dataloggerInfo1 = res.dat;
    //     } else {
    //       this.$message.error(this.$t(`errCode.${res.err}`));
    //     }
    //   });
    // },
    // 查看数采器信息(2)
    // getDataloggerInfo2() {
    //   let param = {
    //     pn: this.deviceInfo.pn
    //   };
    //   this.$request.get("webQueryCollectorsEs", param).then(res => {
    //     if (res.err === 0) {
    //       // console.log('online-数采器信息2', res.dat.collector[0]);
    //       this.dataloggerInfo2 = res.dat.collector[0];
    //     } else {
    //       this.$message.warning(this.$t(`errCode.${res.err}`));
    //     }
    //   });
    // },
    // 获取要充值数采器数据
    queryData(reset) {
      if (this.dataloggerInfo2.descx) {
        if (this.dataloggerInfo2.descx.slice(0, 1) == "G" || this.dataloggerInfo2.descx.slice(0, 1) == "4") {
          this.GprsStatus = true
        } else {
          this.GprsStatus = false
        }
      }
      this.paginationRecharge = false
      if (reset) this.pagination.currentPage = 1
      let param = {
        // page: this.pagination.currentPage - 1,
        // pagesize: this.pagination.pagesize,
        page: 0,
        pagesize: 15,
        cardStatus: this.searchDatalogger.status,
        ccid: this.searchDatalogger.ccid,
        load: this.dataloggerInfo2.load,
        type: 0,
        alias: this.dataloggerInfo2.alias,
        pn: this.dataloggerInfo2.pn,
        // alias: this.dataloggerInfo2.pn,
      }
      this.elLoading = true
      this.$request.get("webQueryGprsCollector", param).then(res => {
        if (res.err == 0) {
          if(res.dat.collector[0].cardType>-1)
          this.GprsStatus = true
          else
          this.GprsStatus = false
          this.dataloggerPay = res.dat.collector
          this.gprsStatus = res.dat.collector[0].gprsStatus
          this.pagination.total = res.dat.total
          // if(this.pagination.total >this.pagination.pagesize){
          //   this.paginationRecharge = true
          // }
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.GprsStatus = false
          this.emptyText = true
          this.dataloggerPay = []
          this.pagination.total = 0
        }
        this.elLoading = false
      })
    },
    // 查询套餐并打开充值弹窗
    fetchPackagesAndOpen(rechargingInfo) {
      this.$request
        .getDEVMicroservices("/ros/api/flow/package/pub/queryGprsRechargeTariffPackage", {
          ctype: rechargingInfo.load,
          cardType: rechargingInfo.cardType,
          'operators': 'CMCC',
          'systemType': '1',
          payWay: this.PaymentMethod,
          i18n: this.$lang.currentLang
        })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            let packages = [];
            res.data.forEach(item => {
              let arr = item.name.split("/");
              packages.push({
                label: arr[0],
                duration: arr[1],
                discount: item.discount,
                finalPrice: item.sellPrice,
                number: item.number
              });
            });
            this.availablePackages = packages;
            rechargingInfo.package = packages.length && packages[0];
            rechargingInfo.channel = this.PaymentMethod;
            this.rechargingInfo = rechargingInfo;
            this.showRechargeDialog = true;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 充值-打开充值弹窗
    openRecharge(info) {
      // 充值-获取该数采器相关数据
      let param = {
        // page: this.pagination.currentPage - 1,
        // pagesize: this.pagination.pagesize,
        page: 0,
        pagesize: 10,
        cardStatus: this.searchDatalogger.status,
        ccid: this.searchDatalogger.ccid,
        load: info.load,
        // alias: info.alias,
        type: 0,
        alias: info.pn
      }
      // 要充值的数采器
      let dataloggerPay
      this.elLoading = true
      this.$request.get("webQueryGprsCollector", param).then(res => {
        if (res.err == 0) {
          dataloggerPay = res.dat.collector
          this.pagination.total = res.dat.total
          // if(this.pagination.total >this.pagination.pagesize){
          //   this.paginationRecharge = true
          // }
          // =================
          // 充值-充值弹窗
          this.showRechargeDialog = true
          if (!dataloggerPay.length) return false
          let initialInfo = {
            type: dataloggerPay[0].type ? 1 : 0,
            load: dataloggerPay[0].load,
            cardType: dataloggerPay[0].cardType,
            pn: [],
            ccid: []
          }
          let rechargingInfo = dataloggerPay.reduce((total, item) => {
            let result = false
            if (total && item.load === total.load&&item.cardType === total.cardType) {
              total.pn.push(item.pn)
              total.ccid.push(item.ccid)
              result = total
            }
            return result
          }, initialInfo)
          if (!rechargingInfo) {
            this.$message.warning(this.$t("recharge.Recharge_tip2"))
            return false
          }
          this.fetchPackagesAndOpen(rechargingInfo);
          // this.$request.get("queryGprsRechargeTariffPackage", {
          //   ctype: rechargingInfo.load ,
          //   cardType: rechargingInfo.cardType,
          //   pn: rechargingInfo.pn.join(","),
          //   i18n: this.$lang.currentLang
          // }).then(res => {
          //   if (res.err == 0) {
          //     let packages = []
          //     res.dat.tariffPackage.forEach(item => {
          //       let arr = item.name.split("/")
          //       packages.push({
          //         label: arr[0],
          //         duration: arr[1],
          //         discount: item.discount,
          //         finalPrice: item.sellPrice,
          //         number: item.number
          //       })
          //     })
          //     this.availablePackages = packages
          //     rechargingInfo.package = packages.length && packages[0]
          //     // rechargingInfo.channel = this.PaymentMethod ==0?this.availableChannels[0]:this.availableChannels[1];
          //     rechargingInfo.channel = 0;
          //     this.rechargingInfo = rechargingInfo
          //     this.showRechargeDialog = true
          //   }else if(res.err == 4096||res.err == 4097){
          //     this.$message.warning(this.$t("recharge.Recharge_tip2"))
          //   }else if(res.err == 4098||res.err == 4099||res.err == 4100){
          //     this.$message.warning(this.$t("recharge.Recharge_tip6"))
          //   }else {
          //     this.$message.error(this.$t(`errCode.${res.err}`))
          //   }
          // })
          // =================
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.emptyText = true
          // this.dataloggerPay = {};
          this.pagination.total = 0
        }
        this.elLoading = false
      })
    },
    //点击确定提交充值订单
    conRechargeMethod(){
      // 点击一次提交后禁用该按钮以防止用户连续点击提交
      if (!this.payBtnDisabled) {
        this.payBtnDisabled = true;
      }
      // 参数
      let param = {
        packageNumber: this.rechargingInfo.package.number,
        // channel: this.rechargingInfo.channel.value,
        'systemType': 1,
        // payChannel: this.rechargingInfo.channel,
        payChannel: this.PaymentMethod,
        payScene: 0,
        // pn: this.rechargingInfo.pn.join(","),
        pns: this.rechargingInfo.pn,
        ccids: this.rechargingInfo.ccid,
        // imsis:
        // type: this.rechargingInfo.type,
        load: this.rechargingInfo.load,
      }
      this.$request.postDEVMicroservices("/ros/api/flow/order/createRecharge", param).then(res => {
        if (res.code === 0 && res.data.url) {
          this.currentStep = 2
          this.$nextTick(() => {
            // 生成二维码图片
            new QRCode(this.$refs.qr, {
              text: res.data.url, // 二维码url
              width: 180,
              height: 180
            })
            // 轮询扫码结果
            this.orderResultPolling && clearInterval(this.orderResultPolling)
            this.orderResultPolling = setInterval(() => {
              this.$request
                .getDEVMicroservices("/ros/api/flow/order/pub/queryRechargeOrderDetails", {
                  orderNo: res.data.orderno
                })
                .then(res => {
                  if (res.code === 0 && (res.data.payStatus == 2 || res.data.payStatus == 6)) {
                    this.currentStep = 3
                    var qrcodeElement = this.$refs.qr;
                    while (qrcodeElement.firstChild) {
                      qrcodeElement.removeChild(qrcodeElement.firstChild);
                    }
                  }
                })
            }, 2000)
          })
        } else {
          // this.$message.error(this.$t(`errCode.${res.err}`));
          this.errorMsgTip = res.message;
          this.currentStep = 4;
        }
        this.payBtnDisabled = false;
      }).catch(() => {
        this.errorMsgTip = this.$t(`errCode.2`)
        this.currentStep = 4
        this.payBtnDisabled = false;
      })
    },
    PaymentMethodClick(val){
      this.PaymentMethod = val
      this.rechargingInfo.channel = val;
      // 切换支付方式后重新查询套餐
      this.fetchPackagesAndOpen(this.rechargingInfo);
    },
    // 选择充值支付方式
    confirmPay() {
      // this.currentStep = 2;
      // this.PaymentMethod = 0;
      this.payBtnDisabled = false;
      this.conRechargeMethod();
    },
    // 充值-关闭充值弹窗
    closeRechargeDialog() {
      this.showRechargeDialog = false
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.devicebelonginfo {
  background: rgb(34, 45, 53);
  // box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .infobox {
    display: grid;
    // width: 600px;
    grid-template-columns: 1fr 1fr 4px 1fr 1fr;
    grid-template-rows: auto auto auto auto auto auto auto auto;
    grid-template-areas:
      "a1 a1 a1 a1 a1"
      "a11 a12 ss1 a13 a14"
      "a21 a22 ss2 a23 a24"
      "a31 a32 ss3 a33 a34"
      "a41 a42 ss4 a43 a44"
      "a3 a3 a3 a3 a3"
      "a71 a72 ss7 a73 a74"
      "a2 a2 a2 a2 a2"
      "a51 a52 ss5 a53 a54"
      "a61 a62 ss6 a63 a64";

    // ......................
    .ggTitle1 {
      grid-area: a1;
    }

    .ggCell11 {
      grid-area: a11;
    }

    .ggCell12 {
      grid-area: a12;
    }

    .ggCell13 {
      grid-area: a13;
    }

    .ggCell14 {
      grid-area: a14;
    }

    //
    .ggCell21 {
      grid-area: a21;
    }

    .ggCell22 {
      grid-area: a22;
    }

    .ggCell23 {
      grid-area: a23;
    }

    .ggCell24 {
      grid-area: a24;
    }

    //
    .ggCell31 {
      grid-area: a31;
    }

    .ggCell32 {
      grid-area: a32;
    }

    .ggCell33 {
      grid-area: a33;
    }

    .ggCell34 {
      grid-area: a34;
    }

    .ggCell41 {
      grid-area: a41;
    }

    .ggCell42 {
      grid-area: a42;
    }

    .ggCell43 {
      grid-area: a43;
    }

    .ggCell44 {
      grid-area: a44;
    }

    // ......................
    .ggTitle3 {
      grid-area: a3;
    }

    .ggCell71 {
      grid-area: a71;
    }

    .ggCell72 {
      grid-area: a72;
    }

    .ggCell73 {
      grid-area: a73;
    }

    .ggCell74 {
      grid-area: a74;
    }

    // ......................
    .ggTitle2 {
      grid-area: a2;
    }

    .ggCell51 {
      grid-area: a51;
    }

    .ggCell52 {
      grid-area: a52;
    }

    .ggCell53 {
      grid-area: a53;
    }

    .ggCell54 {
      grid-area: a54;
    }

    .ggCell61 {
      grid-area: a61;
    }

    .ggCell62 {
      grid-area: a62;
    }

    .ggCell63 {
      grid-area: a63;
    }

    .ggCell64 {
      grid-area: a64;
    }

    // 分割竖盒
    .ggCell01 {
      grid-area: ss1;
    }

    .ggCell02 {
      grid-area: ss2;
    }

    .ggCell03 {
      grid-area: ss3;
    }

    .ggCell04 {
      grid-area: ss4;
    }

    .ggCell05 {
      grid-area: ss5;
    }

    .ggCell06 {
      grid-area: ss6;
    }

    .ggCell07 {
      grid-area: ss7;
    }

    // ......................
    .title {
      // grid-column: 1 / span 2;
      // grid-row: 1;
      // height: 46px;
      // line-height: 46px;
      // height: 4.5vh;
      line-height: 46px;
      padding: 0px 20px;
      background: rgba(65, 80, 90, 1);
      color: rgba(235, 235, 235, 1);
      font-weight: bold;
      font-size: 16px;
      position: relative;
    }

    .cell {
      // height: 38px;
      // line-height: 38px;
      // height: 4vh;
      // box-shadow: -1px 0px rgba(198, 209, 221, 0.5) inset;
      display: flex;
      align-items: center;
      line-height: 24px;
      padding: 0px 16px;
      box-shadow: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: 12px;
      // overflow-y: scroll;
      height: 56px;
    }

    // 信息表格分割系列=====
    // 分割横线H
    .splitHLine {
      border-bottom: 1px solid rgba(198, 209, 221, 0.3);
    }

    // 分割竖线V
    // .splitVLine {
    //   border-bottom: 1px solid rgba(198,209,221,0.3);
    // }
    // 分割竖盒VBox
    .splitVBox {
      width: 4px;
      height: 100%;
      background: #222d35;
      border-left: 1px solid rgba(198, 209, 221, 0.3);
      border-right: 1px solid rgba(198, 209, 221, 0.3);
    }

    // .name {
    //   grid-column: 1;
    // }
    // .data {
    //   grid-column: 2;
    // }
    .dark {
      background: rgb(34, 45, 53);
    }

    .light {
      background: rgb(43, 56, 66);
    }

    .todetail {
      padding: 6px 12px;
      border: none;
      border-radius: 6px;
      background: @primaryTextColor;
      color: #222d35;
      font-size: 13px;
      position: absolute;
      top: 7px;
      right: 12px;
      z-index: 1;
    }

    .toPay {
      // padding: 0.4vh 1vw;
      padding: 9px 12px;
    }

    // 信号值
    .signalBox {
      margin-top: 16px;
    }
  }

  // 充值对话框
  .dialog-recharge {
    .dialog-outborder {
      width: 708px;
    }

    .dialog-footer {
      .button-hollow,
      .button-hollow:hover {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }
    }

    // 步骤
    .step-one {
      .tag {
        height: 40px;
        line-height: 38px;
        margin-right: 10px;
        border-radius: 4px;
        border: 1px solid rgba(204, 206, 221, 1);
        background: rgba(43, 56, 66, 1);
        color: rgba(242, 242, 242, 1);
        font-size: 16px;
      }

      .package {
        display: inline-block;
        padding: 7px 0;
        width: 110px;
        border-radius: 6px;
        margin: 0 10px 10px 0;
        text-align: center;
        // line-height: 1.3;
        // border: 1px solid @borderColor;
        border: none;
        cursor: pointer;
        background: rgba(43, 56, 66, 1);
        color: rgb(123, 131, 149);
        font-size: 16px;

        &:hover {
          // color: @themeColor;
          // border-color: @themeColor;
          color: @primaryTextColor;
        }

        &.selected {
          // border-color: transparent;
          // color: #fff;
          // background: @themeBg;
          color: @primaryTextColor;
        }
      }

      // 充值套餐（删）
      // .packagebox {
      //   /deep/.el-radio-button {
      //     &.is-active {
      //       span {
      //         color: @primaryTextColor;
      //       }
      //     }
      //   }
      //   /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
      //     box-shadow: none;
      //   }
      //   /deep/.el-radio-button__inner {
      //     display: flex;
      //     flex-direction: column;
      //     justify-content: space-between;
      //     align-items: center;
      //     background: rgba(43, 56, 66, 1);
      //     color: rgb(123, 131, 149);
      //     border: none;
      //     border-radius: 6px;
      //     width: 100px;
      //     height: 74px;
      //     font-size: 16px;
      //     margin-bottom: 10px;
      //     margin-right: 10px;
      //   }
      // }
      // 结算信息
      .settlementbox {
        // width: 620px;
        // height: 192px;
        width: 100%;
        height: auto;
        border-radius: 6px;
        background: rgba(43, 56, 66, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        .settlementinfo {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 16px;

          .settlementnum {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .settlementscan {
            color: rgba(51, 255, 182, 1);
            font-size: 20px;
            margin-bottom: 10px;
          }

          .settlementtip {
            color: rgba(255, 62, 62, 1);
            font-size: 12px;
          }
        }
      }

      .capsule-wrapper {
        display: inline-block;
        width: 150px;
        height: 60px;
        padding: 2px;
        background: @borderColor;
        margin-right: 10px;
        border-radius: 5px;
        cursor: pointer;

        &.selected {
          background: @themeBg;
        }

        .capsule-content {
          background: #fff;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
        }
      }

      .discount {
        .sc(20px, @normalColor);
      }

      .price {
        .sc(20px, @themeColor);
      }

      /deep/.el-form-item__label {
        line-height: 38px;
        color: #ffffff;
      }
      // 支付方式横排
      .payment-method-row {
        display: flex;
        gap: 16px;
      }
      .payment-method-card {
        display: flex;
        align-items: center;
        padding: 12px 20px;
        background: rgba(43, 56, 66, 1);
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid transparent;
        &.active {
          border-color: @primaryTextColor;
        }
        .payment-icon {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          margin-right: 12px;
          object-fit: contain;
        }
        .payment-info {
          display: flex;
          flex-direction: column;
          .payment-name {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #fff;
            .paybaseShow {
              width: 18px;
              height: 18px;
              box-sizing: border-box;
              display: inline-block;
              background-repeat: no-repeat;
              background-position: 50%;
              border-radius: 50%;
              border: 2px solid #333333;
              background-color: rgba(26, 92, 107, 1);
              margin-left: 10px;
            }
            .payChoose {
              border: 2px solid #333333;
              background-color: rgba(26, 92, 107, 1);
              background-image: url(../../../../assets/img/recharge/check.png);
              background-size: 10px 10px;
            }
          }
          .payment-desc {
            font-size: 12px;
            margin-top: 6px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }

    .step-common {
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .step-two {
      .step-common;

      .prompt {
        .sc(14px, #fff);
      }

      .price {
        // .sc(26px, @themeColor);
        .sc(26px, rgba(51, 255, 182, 1));
        line-height: 1.6;
      }

      .qr {
        width: 180px;
        height: 180px;
        margin: 10px 0 15px;
      }

      .info {
        .sc(16px, rgba(51, 255, 182, 1));
        line-height: 1.4;
      }
    }

    .step-three {
      .step-common;

      i {
        .sc(200px, @themeColor);
      }

      .prompt {
        .sc(30px, #333);
      }

      .info {
        margin-top: 20px;
        .sc(16px, #333);
      }
    }
    .step-four {
      text-align: center;
    .weixin{
      display: flex;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #116863;    
      cursor: pointer;
      .rightContent{
        display: flex;
        flex-direction: column;
        height: 70px;    
        margin-left: 30px;
        .weixinHeard{
          height: 30px;
          display: flex;
          align-items: center;
        }
      }
      }
      .paybaseShow{
        width: 24px;
        height: 24px;
        box-sizing: border-box;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: 50%;
        border-radius: 50%;
        border: 2px solid #333333;;
        background-color: rgba(26, 92, 107, 1);
        margin-left: 20px;
      }
      .weixinPayTip{
        font-size: 16px; 
        margin-top: 15px;
        text-align: left;
        color: rgba(255, 255, 255, 0.556862745098039);
      }
      .payChoose{
        border: 2px solid #333333;;
        background-color: rgba(26, 92, 107, 1);
        background-image: url(../../../../assets/img/recharge/check.png);
        background-size: 14px 14px;
      }
      .showresultbtn {
            // width: 102px;
            padding: 0 10px;
            height: 30px;
            margin-top: 10px;
            border-radius: 6px;
            background: @primaryTextColor;
            color: rgba(34, 45, 53, 1);
            font-size: 14px;
          }
    }

    .step-two,
    .step-three {
      // 充值结果提示
      .showresultbox {
        display: flex;
        flex-direction: column;
        align-items: center;

        .showsuccess {
          border: 3px solid rgba(37, 255, 174, 1);
          background-color: rgba(19, 195, 156, 1);
          background-image: url(../../../../assets/img/general/Icon_Finished.png);
          background-size: 70px 70px;
        }

        .showfail {
          border: 3px solid rgba(246, 189, 189, 1);
          background: rgba(251, 75, 75, 1);
          background-image: url(../../../../assets/img/general/Icon_Failed.png);
          background-size: 120px 120px;
        }

        .showbase {
          width: 100px;
          height: 100px;
          box-sizing: border-box;
          background-repeat: no-repeat;
          background-position: center;
          border-radius: 50%;
        }

        .showresultname {
          font-weight: bold;
          font-size: 18px;
          line-height: 36px;
          margin-top: 30px;
          color: rgba(255, 255, 255, 1);
        }

        .showresulttip {
          color: rgba(255, 255, 255, 0.7);
          font-size: 14px;
          margin-top: 18px;
        }

        .showresulttext {
          font-weight: bold;
          font-size: 18px;
          margin-top: 20px;
          margin-bottom: 30px;
          color: rgba(255, 255, 255, 1);
        }

        .showoperate {
          text-align: center;
        }

        .showresultbtn {
          // width: 102px;
          padding: 0 10px;
          height: 30px;
          margin-top: 10px;
          border-radius: 6px;
          background: @primaryTextColor;
          color: rgba(34, 45, 53, 1);
          font-size: 14px;
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>